import React from 'react';
import { withRouter } from 'react-router-dom';

import ContentLayout from 'component/page/content';
import { LoaderRipple } from 'component/loader';
import {saveToken, saveLoginMeta, clearLoginMeta } from 'utils/authentication';

import API, {handleError} from 'utils/xhr';
import Track from 'utils/tracker';


class Page extends React.Component {
  render (){
    return (
      <ContentLayout id="ghost-page">
        <Ghosting />
      </ContentLayout>
    )
  }
}

class Ghosting extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      ghost_user_xid: '',
      ghosting_allowed: null,
    }
  }

  componentDidMount(){
    const url = '/users/ghost';
    API.get(url).then(response =>{
      console.log(response.data.data);
      const state = this.state;
      state.ghosting_allowed = response.data.data.ghosting_allowed;
      this.setState(state);
    },(error) =>{
      handleError(error, this.props.history, window.location.pathname);
    })
  }

  onChange(e){
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  ghostUser(e) {
    e.preventDefault();

    if (this.state.ghost_user_xid === ''){
      alert("ghost_user_xid cannot be empty!")
      return;
    }

    const url = '/users/ghost';
    var data = {
      ghost_user_xid: this.state.ghost_user_xid,
    }

    API.post(url, data).then(response => {

      const success = response.data.meta.success;
      if (success){
        clearLoginMeta();
        var jwt_token = response.data.data.token;
        saveToken(jwt_token);
        saveLoginMeta(response.data.data.meta);

        const user_xid = response.data.data.meta.user_xid;

        Track.user("ghosting user", user_xid);
        // this.props.history.push('/sites');
        window.location = '/sites';

      } else {
        alert(response.data.data.message);
      }

    }, (error) => {
      Track.user("ghosting failed!");
      handleError(error);
    }, this);
  }

  render (){

    if (this.state.ghosting_allowed === null){
      return (<LoaderRipple fetching_data={true} />)
    }

    if (this.state.ghosting_allowed === false){
      this.props.history.push('/sites');
    }

    return (
      <div className="container">

        <div className="m-3 row">
          <form className="col-xl-6">
          <fieldset className="form-group">

            <span className=" text-dark">Ghost User XID:</span>
            <input 
              className="form-control " 
              name="ghost_user_xid" 
              value={this.state.ghost_user_xid} 
              onChange={this.onChange.bind(this)} />

          </fieldset>
            <button 
              onClick={this.ghostUser.bind(this)} 
              className={"btn btn-rounded btn-danger"}>
                <i className="fa fa-ghost mr-2"></i>Ghost
            </button>

          </form>
        </div>

      </div>
    )
  }
}

export default withRouter(Page);